import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../PaginatedFetchTable';
import Avatar from '../Avatar';
import ConfirmedAsyncFunctionTrigger from '../ConfirmedAsyncFunctionTrigger';
import DateTimeDisplay from '../DateTimeDisplay';

export default class StaffBookingsList extends Component {
  static propTypes = {
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    defaultSort: null,
    apiUrl: '',
  }

  renderRow(item) {
    return (
      <tr key={item.id}>
        <td>
          <div className="u-truncate">
            { item.room_name }
          </div>
        </td>
        <td>
          <div className="u-truncate">
            { item.title }
          </div>
        </td>
        <td>
          { item.user
            && (
              <a href={item.user.staff_url}>
                <div className="u-flex u-items-center">
                  <Avatar
                    className="StaffTable-avatar u-mr-2"
                    src={item.user.avatar_url}
                    type="user"
                    showInitials
                    name={item.user.name}
                  />
                  <div className="u-font-semibold u-truncate">
                    {item.user.name}
                  </div>
                </div>
              </a>
            ) }
        </td>
        <td>
          <div className="u-truncate">
            <div className="u-inline-block u-mr-4">
              { item.companies
                  && item.companies.map(company => (
                    <Avatar
                      className="StaffTable-avatar Avatar--facepile Avatar--facepile-frozen u-align-middle"
                      src={company.avatar_url}
                      type={company.type}
                      href={company.staff_url}
                      showInitials
                      name={company.name}
                    />
                  ))}
            </div>
            { item.companies
                && item.companies.map(company => (
                  <a
                    className="u-font-semibold comma-separated"
                    href={company.staff_url}
                  >
                    {company.name}
                  </a>
                ))}
          </div>
        </td>
        <td>
          {this.currentIndicator(item)}
          <DateTimeDisplay tag="span" timestamp={item.start_time} useTimeZone={item.room_timezone} />
        </td>
        <td>{ item.duration }</td>

        <td className="actions">
          <ConfirmedAsyncFunctionTrigger
            method="delete"
            url={item.delete_staff_url}
            triggerLabel=""
            triggerIcon="Icon-delete"
            triggerIconExtraClassName=""
            triggerClassName="Button Button--red"
            triggerExtraClassName=""
            buttonConfirmLabel="Yes, delete booking"
            buttonConfirmClassName="Button--primary Button--red"
            buttonCancelLabel="No, go back"
            buttonCancelClassName="Button Button--grey"
            modalHeader="Delete booking?"
            modalBody="Are you sure you want to delete this booking? If so, please ensure that you let the booking owner know of the change."
          />
        </td>
      </tr>
    );
  }

  currentIndicator = (item) => {
    if (Date.now() < (new Date(item.end_time)).getTime() && Date.now() > (new Date(item.start_time)).getTime()) {
      return (
        <div className="indicator-current" />
      );
    }
  }

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow.bind(this)}
      />
    );
  }
}
